const regeneration = {
  regeneration: {
    initial: {
      data: [
        {
          label: 'x-label:workflow3.regeneration.set brake and neutral',
          center: true
        }
      ],
      icons: ['icon-xm-p-dark', 'icon-xm-n-dark']
    },
    start: {
      data: [
        {
          label: 'x-label:workflow3.regeneration.screen2.start regen?',
          center: true
        }
      ],
      icons: ['icon-xm-warning', 'icon-xm-wind']
    },
    active: {
      data: [
        {
          label: 'x-label:workflow3.regeneration.screen3.regen active',
          center: true
        }
      ],
      icons: ['icon-xm-warning', 'icon-xm-wind']
    },
    interrupted: {
      data: [
        {
          label: 'x-label:workflow3.regeneration.screen4.regen interrupted',
          center: true
        }
      ],
      icons: ['icon-xm-no-wind']
    },
    complete: {
      data: [
        {
          label: 'x-label:workflow3.regeneration.screen5.regen complete',
          center: true
        }
      ]
    }
  }
};

export default regeneration;



// WEBPACK FOOTER //
// ./src/screens/data/flow3/regeneration.js